module.exports = __webpack_public_path__ + "static/media/7x7grid.d5678358.png";